import React from 'react';
import PropTypes from 'prop-types';
import {ModalWindow} from './ModalWinodw';
import {PSImage} from './PSImage';
import {Tooltip} from './Tooltip';
import {Wrapper} from './Wrapper';
import {I18nextProvider} from 'react-i18next';
import i18next from './locales/i18next';

import './style.scss';

export const PowerSupplyContext = React.createContext();

const i18n = i18next;

const changeLang = (lang) => {
  i18n.changeLanguage(lang);
};

export function PowerSupply(props) {
  const [hover, setHover] = React.useState();

  const onMouseEnter = () => setHover(true);
  const onMouseLeave = () => setHover(false);

  React.useEffect(() => {
    props.lang && changeLang(props.lang);
  }, [props.lang]);

  return (
    <I18nextProvider i18n={i18n}>
      <PowerSupplyContext.Provider
        value={{
          power: props.power,
          powerSupplyPluggedIn: props.pluggedIn,
          gelBoxPluggedIn: props.interactionProps.gelBoxes[0].anodeConnected &&
                           props.interactionProps.gelBoxes[0].cathodeConnected,
          running: props.running,
          completed: props.completed,
        }}>
        <Wrapper
          className='powerSupply'
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}>
          <div className='powerSupply_filler' />
          <Tooltip hover={hover} onClick={props.toggleModal} />
          <PSImage onClick={props.toggleModal} />
        </Wrapper>
        <ModalWindow
          modalOpen={props.modalOpen}
          toggleModal={props.toggleModal}
          togglePower={props.togglePower}
          settingsData={props.settingsData}
          setTimer={props.setTimer}
          setVoltage={props.setVoltage}
          setCurrent={props.setCurrent}
          cablesData={props.cablesData}
          player={props.player}
          onClickStart={props.onClickStart}
          onClickStop={props.onClickStop}
          pluggedIn={props.pluggedIn}
          interactionProps={props.interactionProps}
          alert={props.alert}
        />
      </PowerSupplyContext.Provider>
    </I18nextProvider>
  );
}

PowerSupply.propTypes = {
  /**
   * spcifies if power is on
   */
  power: PropTypes.bool,
  /**
   * specified if component is plugged in with both correct cables
   */
  pluggedIn: PropTypes.bool,
  /**
   * specifies if animation is running in timer player
   */
  running: PropTypes.bool,
  /**
   * specifies whether timer player completed animation playback
   */
  completed: PropTypes.bool,
  /**
   * specifies code of language the component is to be rendererd
   */
  lang: PropTypes.oneOf([
    'en',
    'ar',
    'ja',
    'nl',
    'de',
    'es',
    'fr',
    'it',
    'ko',
    'pt',
    'tr',
    'zh',
    'zu',
  ]),

  ...ModalWindow.propTypes,
};

PowerSupply.defaultProps = {};
